<div
  class="my-[30px] flex w-full items-center"
  [ngClass]="{ 'justify-between': toolbarKebabOpen(), 'justify-start': !toolbarKebabOpen() }"
>
  <div class="flex items-center space-x-[24px]">
    <span class="text-2xl font-bold">Investigator Transactions</span>
    <div
      class="ml-3 w-max rounded border px-2 py-1 text-sm font-bold"
      [ngStyle]="{
        'background-color': edcStatus().bgColor,
        'border-color': edcStatus().borderColor,
        color: edcStatus().color,
      }"
    >
      {{ edcStatus().text.toUpperCase() }}
    </div>
    @if (showEdcBanner()) {
      <span>
        {{ edcBanner() }}
      </span>
    }
  </div>
  @if (toolbarKebabOpen()) {
    <aux-menu [showMenuForExternal]="true" #edc_notification_menu>
      <button
        type="button"
        role="menuitem"
        class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
        (click)="onNotifyCustomer(); edc_notification_menu.close()"
      >
        <span>{{ firstKebabOptionName() }}</span>
      </button>
      @if (showEdcDataAvailable()) {
        <button
          type="button"
          role="menuitem"
          class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
          (click)="onReturnToProcessing(); edc_notification_menu.close()"
        >
          <span>{{ secondKebabOptionName() }}</span>
        </button>
      }
    </aux-menu>
  }
</div>
